import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText, TrendingUp, Search, Award, Settings } from "lucide-react";

const ResourcesSection = () => {
  const resources = [
    {
      title: "Behavioral Health EMR 101",
      description: "Complete guide to behavioral health EMR software and core features",
      icon: FileText,
      href: "/resources/behavioral-health-emr-101"
    },
    {
      title: "EMR Benefits",
      description: "7 key benefits of behavioral health EMR systems for your practice",
      icon: TrendingUp,
      href: "/resources/emr-benefits"
    },
    {
      title: "How to Choose EMR",
      description: "Step-by-step buyer's guide for selecting the right EMR system",
      icon: Search,
      href: "/resources/how-to-choose-emr"
    },
    {
      title: "Top EMR Solutions",
      description: "Rankings and comparison of the best behavioral health EMR software",
      icon: Award,
      href: "/resources/top-emr-solutions"
    },
    {
      title: "EMR Implementation",
      description: "Best practices for successful EMR rollout and team adoption",
      icon: Settings,
      href: "/resources/emr-implementation"
    }
  ];

  return (
    <section className="py-16 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Expert Resources & Guides
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Everything you need to know about selecting and implementing behavioral health EMR software
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-12">
          {resources.map((resource, index) => {
            const Icon = resource.icon;
            return (
              <a href={resource.href} key={index} className="block group">
                <Card className="h-full transition-all duration-300 hover:shadow-lg hover:border-primary/50">
                  <CardHeader>
                    <div className="flex items-start space-x-3">
                      <div className="p-2 rounded-lg bg-primary/10 group-hover:bg-primary/20 transition-colors">
                        <Icon className="w-6 h-6 text-primary" />
                      </div>
                      <CardTitle className="text-lg group-hover:text-primary transition-colors">
                        {resource.title}
                      </CardTitle>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground">
                      {resource.description}
                    </p>
                  </CardContent>
                </Card>
              </a>
            );
          })}
        </div>

        {/* Additional crawlable links for blog posts */}
        <Card className="max-w-6xl mx-auto bg-background/50">
          <CardHeader>
            <CardTitle className="text-xl">Popular EMR Guides & Comparisons</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 text-sm">
              <a href="/blog/best-ehr-emr-software" className="text-primary hover:underline">Best EHR/EMR Software 2025</a>
              <a href="/blog/best-rcm-software" className="text-primary hover:underline">Best RCM Software Solutions</a>
              <a href="/blog/best-healthcare-crm-software" className="text-primary hover:underline">Best Healthcare CRM Software</a>
              <a href="/blog/best-ehr-behavioral-health" className="text-primary hover:underline">Best EHR for Behavioral Health</a>
              <a href="/blog/best-ehr-psychiatry" className="text-primary hover:underline">Best EHR for Psychiatry</a>
              <a href="/blog/best-ehr-mental-health-clinics" className="text-primary hover:underline">Best EHR for Mental Health Clinics</a>
              <a href="/blog/best-ehr-addiction-treatment" className="text-primary hover:underline">Best EHR for Addiction Treatment</a>
              <a href="/blog/best-ehr-substance-abuse" className="text-primary hover:underline">Best EHR for Substance Abuse</a>
              <a href="/blog/best-ehr-solo-practices" className="text-primary hover:underline">Best EHR for Solo Practices</a>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default ResourcesSection;
